import type { photosEdl as Fr } from '../fr/photosEdl';

/** « photosEdl » in English — typed on the French: a missing sentence does not compile. */
export const photosEdl: typeof Fr = {
  titre: 'Vehicle photos',
  retirer: 'remove',
  erreurImage: 'This image could not be processed. Please try again.',
  explication: (ko: number) => `Each photo is reduced to 1600 px and compressed on the phone (${ko} KB in total). That keeps the server from filling up — and it is what will win you a dispute.`,
  vues: {
    avant: 'Front', arriere: 'Rear', cote_gauche: 'Left side', cote_droit: 'Right side',
    interieur: 'Interior', compteur: 'Odometer',
  },
  compressionImpossible: 'Compression failed',
  tropLourde: 'Photo too large to upload.',
  tropLent: 'Connection too slow — try again closer to the office.',
  envoiImpossibleCode: (code: number) => `Upload failed (${code})`,
  envoiPhotosImpossible: 'Photo upload failed',
};
